/* Footer link columns: plain lists on desktop, accordions on phone (CSS decides which; this wires the toggles). */
if (!customElements.get('vc-footer-accordion')) {
  customElements.define('vc-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.vc-footer__toggle').forEach((btn) => {
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', String(open));
          const panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) panel.classList.toggle('is-open', open);
        });
      });
    }
  });
}
